var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "hkl-guideline" },
    _vm._l(_vm.guidelines, function (section, i) {
      return _c(
        "Collapse",
        _vm._b(
          {
            key: section.id,
            ref: "collapseRefs",
            refInFor: true,
            staticClass: "small-12",
          },
          "Collapse",
          _vm.proxyAttrs,
          false
        ),
        [
          _c("template", { slot: "title" }, [
            _c(
              "div",
              { staticClass: "hkl-guideline__title" },
              [
                _vm._t(
                  "secTitle",
                  function () {
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.parseOrderNumber(section.displayOrder))
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(section.value))]),
                    ]
                  },
                  { section: section, index: i }
                ),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c(
            "template",
            { slot: "additional" },
            [_vm._t("secTitleAction", null, { section: section, index: i })],
            2
          ),
          _vm._v(" "),
          _c(
            "template",
            { slot: "content" },
            _vm._l(section.sectionContent, function (item, j) {
              return _c(
                "div",
                { key: item.id, staticClass: "hkl-guideline__child-box" },
                [
                  _c(
                    "div",
                    { staticClass: "hkl-guideline__child-contentbox row" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "hkl-guideline__child-content small-12",
                        },
                        [
                          _vm._t(
                            "item",
                            function () {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass: "hkl-guideline__child-number",
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.parseOrderNumber(j + 1)) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "pre",
                                  { staticClass: "hkl-guideline__child-value" },
                                  [_vm._v(_vm._s(item.value))]
                                ),
                              ]
                            },
                            {
                              section: section,
                              sectionItem: item,
                              parentIndex: i,
                              index: j,
                            }
                          ),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm._l(item.actionTexts, function (rec, k) {
                        return [
                          rec
                            ? _c(
                                "div",
                                {
                                  key: item.id + "_" + k,
                                  staticClass: "tip small-12",
                                },
                                [
                                  _c("span", { staticClass: "tip__text" }, [
                                    _vm._v(_vm._s(rec)),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                        ]
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm._t("itemAction", null, {
                    section: section,
                    sectionItem: item,
                    parentIndex: i,
                    index: j,
                  }),
                ],
                2
              )
            }),
            0
          ),
        ],
        2
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }